<h1 mat-dialog-title>

    <b>Información Cuota</b>
</h1>
<br />
<form #validarForm=ngForm>

    <dialog-content>
        <p>
            <form-field appearance="outline" class="mat-input">
                <mat-label> Solicitante </mat-label>

                <mat-option>{{data.rutUsuario}} {{data.nombreUsuario}} </mat-option>

            </form-field>
        </p>
        <p>
            <mat-form-field appearance="outline" class="mat-input">
                <mat-label> Monto Total Cuota</mat-label>
              
                <input name="monto" matInput type="number" placeholder="monto" [(ngModel)]="data.monto"
                required #monto="ngModel"  [disabled]="true">

            </mat-form-field>
        </p>

      
        <p>
            <mat-form-field appearance="outline" class="mat-input">

                <mat-label> Fecha Cuota </mat-label>

                <input name="fechaCuota" matInput type="date" placeholder="Fecha Cuota" [(ngModel)]="data.fechaCuota"
                    required #fechaCuota="ngModel" [disabled]="true">

            </mat-form-field>
        </p>

        <p>
            <mat-form-field appearance="outline" class="mat-input">

                <mat-label> Fecha Pago</mat-label>

                <input name="fechaPago" matInput type="date" placeholder="Fecha Pago" [(ngModel)]="data.fechaPago"
                    required #fechaPago="ngModel" [disabled]="true">

            </mat-form-field>
        </p>

        <p>
            <form-field appearance="outline" class="mat-input">
                <mat-label> Descargar Comprobante Pago</mat-label>
                <div class="col-lg-6">
                    <button class="btn-info mat-raised-button" (click)="onDescargarArchivosClick(data.id)">

                        <i class="fa fa-download"> </i> Descargar Archivo Ingresado </button>
                </div>

            </form-field>

        </p>
      
        <p *ngIf="data.estado == 'RECHAZADA' && data.nombreMotivoRechazo">
            <form-field appearance="outline" class="mat-input">
                <mat-label> Opción de rechazo </mat-label>
                <mat-option> {{data.nombreMotivoRechazo}} </mat-option>

            </form-field>
        </p>
    
        <p *ngIf="data.estado == 'RECHAZADA' && data.motivoRechazo">
            <form-field appearance="outline" class="mat-input">
                <mat-label> MotivoRechazo </mat-label>
                <mat-option> {{data.motivoRechazo}} </mat-option>

            </form-field>
        </p>
        <p *ngIf="data.estado == 'ANULADA REVERSADA' && data.motivoAnulacion">
            <form-field appearance="outline" class="mat-input">
                <mat-label> Motivo Anulación </mat-label>
                <mat-option> {{data.motivoAnulacion}} </mat-option>

            </form-field>
        </p>


    </dialog-content>
</form>
<br />
<mat-dialog-actions>
    <div>
        <button  mat-button *ngIf="data.mostrarEditar" class="mat-raised-button btn-warning" (click)="onEditarPagoClick(data.id)"> 
            <i class ="fa fa-pen"> </i> Editar
        </button>

        <button mat-button *ngIf="data.mostrarEditar" mat-button class="mat-raised-button btn-success" (click)="onGuardarClick(data.id)">
            <i class = "fa fa-download"> </i> Guardar
        </button>

        <button mat-button *ngIf="data.mostrarEditar" class="mat-raised-button btn-success" (click)="onAprobarPagoClick(data.id)">
            <i class="fa fa-check"> </i> Aceptar
        </button>

        <button mat-button *ngIf="data.mostrarEditar" class="mat-raised-button btn-danger" (click)="onRechazarPagoClick(data.idUsuario)">
            <i class="fa fa-trash"> </i> Rechazar
        </button>

        <button mat-button class="mat-raised-button btn-secondary" (click)="onCancelarClick()">
            <i class="fa fa-trash"> </i> Salir
        </button>
    </div>
   
</mat-dialog-actions>

<br />